var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconLeftNRight24Line = function SvgIconLeftNRight24Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.36 16.615 4.6 13.05A1.445 1.445 0 0 1 4.15 12c0-.395.165-.78.45-1.05l3.76-3.565L9.53 8.62l-3.57 3.385 3.57 3.385-1.17 1.235v-.01ZM15.64 16.615l-1.17-1.235 3.57-3.385-3.57-3.385 1.17-1.235 3.76 3.565c.29.275.45.655.45 1.05s-.165.78-.45 1.05l-3.76 3.565v.01Z",
    fill: "current"
  })));
};
export default SvgIconLeftNRight24Line;